function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#EFEFEF"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M23.859 3.153c10.658 0 19.298 8.67 19.298 19.363 0 .777-.046 1.543-.134 2.297H15.682c0 5.075 3.514 9.19 7.85 9.19 2.905 0 5.442-1.849 6.8-4.595h11.567c-2.769 7.29-9.802 12.47-18.04 12.47-9.066 0-16.672-6.272-18.742-14.728l6.64-12.182s-4.045 3.365-7.188 7.003c.287-10.442 8.814-18.818 19.29-18.818zm-.327 9.19c-3.556 0-6.56 2.767-7.525 6.562h15.05c-.966-3.795-3.97-6.563-7.525-6.563z",
  transform: "translate(-539 -423) translate(480 263) translate(59 160)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.903 13.215C24.47 2.649 36.34-2.612 40.414 1.463c2.38 2.38 1.577 7.42-1.609 13.304 2.195-4.69 3.063-8.701 1.324-10.442-4.193-4.198-14.504 1.78-24.123 11.398C6.388 25.342.195 35.383 4.223 39.411c1.447 1.448 4.736 1.292 8.529.027-4.699 2.038-8.593 2.294-10.6.288-4.076-4.076 1.185-15.946 11.751-26.511z",
  transform: "translate(-539 -423) translate(480 263) translate(59 160)"
})))));

var SvgIe = function SvgIe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ie.c8293c3f.svg";
export { ForwardRef as ReactComponent };